import { useMemo } from 'react';
import ModalSlider from '../modal-slider/modal-slider';
import BPMS_Feautre_Filters from '../../../assets/onboarding/2.3/BPMS_Feautre_Filters.gif';

export function BPMSupremeQ23Filters() {
    const data = useMemo(
        () => [
            {
                image: BPMS_Feautre_Filters,
                title: 'Filters Just Got an Upgrade🪄',
                text: 'Filters now live at the top of track lists for quicker and easier access, taking your music discovery to the next level. See how many tracks match a genre before filtering, view the results instantly, and remove active filters quickly.'
            }
        ],
        []
    );

    return <ModalSlider title="Feature Update" type="BPMSupremeQ23Filters" sliderItems={data} />;
}

export default BPMSupremeQ23Filters;
